import React from 'react';
import { timeAgo } from '../utils/time';
import Icon from './Icon';
import './AdminPanel.css';

export const SourceLink = ({ url }) => (/^https?:/.test(url || '')
  ? <a className="adm-source-link" href={url} target="_blank" rel="noopener noreferrer">source</a>
  : <span className="adm-source-link">{url?.startsWith('apollo:') ? 'Apollo' : null}</span>);

/** One proposed finding, shown wherever someone can decide on it: the admin review queue, or the
 * subject's own panel. showSubject is off in the latter case — the subject is already on screen. */
const FindingCard = ({ finding, onDecide, busy, showSubject = true }) => (
  <li className="adm-event adm-finding">
    <div className="adm-event__line">
      <span className="adm-event__who">{finding.label}{showSubject ? ` of ${finding.subject_name}` : ''}</span>
      <span className="adm-event__when">{timeAgo(finding.created_at)}</span>
    </div>
    <div className="adm-event__summary">{finding.value}</div>
    {finding.on_file && <div className="adm-finding__meta">On file now: {finding.on_file}</div>}
    <blockquote className="adm-finding__quote">
      {finding.evidence} <SourceLink url={finding.source_url} />
    </blockquote>
    <div className="adm-finding__actions">
      <button type="button" className="rm-button rm-button--primary" disabled={busy} onClick={() => onDecide(finding, 'accept')}>
        <Icon name="check" /> Accept
      </button>
      <button type="button" className="rm-button rm-button--quiet" disabled={busy} onClick={() => onDecide(finding, 'reject')}>
        Reject
      </button>
    </div>
  </li>
);

export default FindingCard;
